import { Vue, Component, Prop } from 'vue-property-decorator';
import { createNamespacedHelpers } from 'vuex';
import messageMutationsType from '@/modules/messaging/store/mutations-types';
import MessagesList from '@/modules/messaging/components/flash-messages-list/flash-messages-list.vue';

const { mapState } = createNamespacedHelpers('messages');

@Component({
	computed: {
		...mapState(['globalMessages'])
	},

	components: {
		'messages-list': MessagesList
	}
})
export default class GlobalMessages extends Vue {
	handleMessageRemove(messageId: string): void {
		this.$store.commit(`messages/${messageMutationsType.REMOVE_MESSAGE}`, messageId);
	}
}
